import { createEmptyCollection } from 'helpers/normalizeHelpers'
import { Reducer } from 'interfaces'
import { CreditCardDataState } from 'components/features/creditCard/creditCardStore/state'
import { GetCCPaymentsAction } from 'components/features/creditCard/creditCardStore/actions'

const INITIAL_STATE = createEmptyCollection()
export const ccPaymentsReducer: Reducer<CreditCardDataState['payments']> = (prevState = INITIAL_STATE, action) => {
  switch (action.type) {
    case GetCCPaymentsAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      return action.payload.response
    }
  }

  return prevState
}
